



























































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountDeed } from '@/shared/clients/client-account-deed';
import { ClientPowerOfAttorney } from '@/shared/clients/client-power-of-attorney';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { PowerOfAttorneyType } from '@/shared/types/power-of-attorney-type';
import { WillType } from '@/shared/types/will-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');

@Component
export default class ClientAccountDetail extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @typesModule.Getter('clientOriginalSourceTypes') private clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;
    @typesModule.Getter('powerOfAttorneyTypes') private powerOfAttorneyTypes!: Array<PowerOfAttorneyType>;
    @typesModule.Getter('willTypes') private willTypes!: Array<WillType>;

    @Prop({ required: true }) private client!: ClientAccount | null;

    private clientItems: Array<ClientAccount> = this.client == null ? [] : [this.client];

    private get clientFields(): Array<{}> {
        return [
            { key: 'accountNo', label: 'Account No' },
            { key: 'name', label: 'Name' },
            { key: 'addressLine1', label: 'Address Line 1' },
            { key: 'postcode', label: 'Postcode' },
            { key: 'partnerPractice', label: 'Assigned To' },
            { key: 'originalSource', label: 'Introducer' },
            { key: 'documents', label: 'Documents' },
            { key: 'actions', label: '' },
        ];
    }

    private get clientFullName(): string {
        return this.client == null ? '' : `${this.client.firstName != null ? this.client.firstName.trim() : ''} ${this.client.lastName != null ? this.client.lastName.trim() : ''}`;
    }

    private get originalSourceDescription(): string {
        if (this.client == null) {
            return '';
        }

        const clientOriginalSourceType = this.clientOriginalSourceTypes.find((type) => type.id === this.client!.originalSourceId);
        return clientOriginalSourceType == null ? '' : clientOriginalSourceType.value;
    }

    private get willTypeDescription(): string {
        if (this.client == null) {
            return '';
        }

        const willType = this.willTypes.find((type) => type.id === this.client!.will!.willTypeId);
        return willType == null ? '' : willType.value;
    }

    @Watch('client')
    private onClientChanged(client: ClientAccount | null): void {
        this.clientItems = client == null ? [] : [client];
    }

    private powerOfAttorneyTypeDescription(powerOfAttorney: ClientPowerOfAttorney): string {
        const powerOfAttorneyType = this.powerOfAttorneyTypes.find((type) => type.id === powerOfAttorney.powerOfAttorneyTypeId);
        return powerOfAttorneyType == null ? '' : powerOfAttorneyType.value;
    }

    private deedDescription(deed: ClientAccountDeed): string {
        return `Deed - ${deed.addressLine1}, ${deed.postcode}`;
    }
}
